import { i18n } from '~i18n'
import { RouteNames } from '../routeNames'


export const BACK_BUTTON_LABELS: Record<string, string> = {
  get default () {
    return i18n.t('general.backButton.default')
  },

  get [RouteNames.About] () {
    return i18n.t('general.backButton.about')
  },
}
